
import { getListOfLoginSessions } from "../types/account_sessions_types";

export const getListOfLoginSessionsRequest = (data) => ({
    type: getListOfLoginSessions.REQUEST,
    payload: data,
});

export const getListOfLoginSessionsSuccess = (data) => ({
    type: getListOfLoginSessions.SUCCESS,
    payload: data
});

export const getListOfLoginSessionsFailure = (error) => ({
    type: getListOfLoginSessions.FAILURE,
    payload: error
});
